import brandStyleFieldDefinitions from "./brandStyleFields";
import type { OnboardingFormValues } from "../hooks/useFormData";

/** Single link-styles CSS rule; shared by the generic and product-grid paths. */
export function buildLinkStyles(
  selector: string,
  color: string | number | undefined,
  textDecoration: string | number | undefined,
  fontWeight: string | number | undefined,
) {
  return `${selector} { color: ${color}; text-decoration: ${textDecoration}; font-weight: ${fontWeight}; }`;
}

export function mergeBkLinkProperties(formValues: OnboardingFormValues) {
  const color = formValues["textLinkColor"] as string;
  const fallbackColor = brandStyleFieldDefinitions.find(
    (field) => field.id === "textLinkColor",
  )?.value;
  const textDecoration =
    formValues["textLinkUnderline"] === 0 ? "none" : ("underline" as string);
  const fallbackTextDecoration = brandStyleFieldDefinitions.find(
    (field) => field.id === "textLinkUnderline",
  )?.value;
  const fontWeight = formValues["textLinkFontWeight"] as string;
  const fallbackFontWeight = brandStyleFieldDefinitions.find(
    (field) => field.id === "textLinkFontWeight",
  )?.value;
  return buildLinkStyles(
    ".bk-link",
    color || fallbackColor,
    textDecoration || fallbackTextDecoration,
    fontWeight || fallbackFontWeight,
  );
}
